import type { FC } from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

interface RotateKeyDialogProps {
  readonly open: boolean
  readonly onClose: () => void
  readonly onConfirm: () => void
  readonly isRotating: boolean
}

export const RotateKeyDialog: FC<RotateKeyDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isRotating,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isRotating ? undefined : onClose}
      aria-labelledby="rotate-key-dialog-title"
      aria-describedby="rotate-key-dialog-description"
    >
      <DialogTitle id="rotate-key-dialog-title">Rotate Encryption Key?</DialogTitle>
      <DialogContent>
        <DialogContentText id="rotate-key-dialog-description">
          A new key will be generated for future encryption. Old keys remain available for
          decrypting historical data. Distribute the updated key ring file to all your daemons.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isRotating} aria-label="Cancel key rotation">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isRotating}
          variant="contained"
          aria-label={isRotating ? 'Rotating encryption key' : 'Confirm key rotation'}
        >
          {isRotating ? <CircularProgress size={20} aria-hidden="true" /> : 'Rotate'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
